var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WmOption, WmSelect, WmToggletip } from "@watermarkinsights/ripple-react";
import { useContext, useEffect, useReducer } from "react";
import { useIntl } from "react-intl";
import { sendRequest, sendRequestWithPayload } from "src/common/http";
import translate from "src/i18n/translate";
import CourseCompletionRisk from "./CourseCompletionRisk";
import TermPersistenceRisk from "./TermPersistenceRisk";
import "./Sse.scss";
import { formatNumber } from "../../../src/static/js/commons";
import WidgetLoader from "../common/elements/WidgetLoader";
import { getLoaderStatus } from "../common/helper";
import ApiError from "../common/elements/ApiError";
import { WmButton } from "@watermarkinsights/ripple-react";
import { downloadPDF } from "../common/helper";
import { AppContext } from "src/contexts/AppContext";
var initialState = {
    showSseWidget: false,
    isExportInProgress: false,
    terms: [],
    averageCourseRisk: "",
    averageTermRisk: "",
    totalEnrollments: 0,
    engaged: 0,
    highRiskCourseEngagement: 0,
    lowRiskCourseEngagement: 0,
    mediumRiskCourseEngagement: 0,
    notIndicatedRiskCourseEngagement: 0,
    highRiskCourseCompletion: 0,
    lowRiskCourseCompletion: 0,
    mediumRiskCourseCompletion: 0,
    notIndicatedRiskCourseCompletion: 0,
    highRiskTermPersistence: 0,
    mediumRiskTermPersistence: 0,
    lowRiskTermPersistence: 0,
    notIndicatedRiskTermPersistence: 0,
    highRiskTermPersistenceEngagement: 0,
    lowRiskTermPersistenceEngagement: 0,
    mediumRiskTermPersistenceEngagement: 0,
    notIndicatedRiskTermPersistenceEngagement: 0,
    loader: true,
    termSummaryFailed: false,
    selectedTerm: null,
    token: null
};
var setSseTermSummary = function (sseTermResultSet, state) {
    if (sseTermResultSet.averageCourseRisk) {
        return __assign(__assign({}, state), { averageCourseRisk: sseTermResultSet.averageCourseRisk, averageTermRisk: sseTermResultSet.averageTermRisk, totalEnrollments: sseTermResultSet.totalEnrollments, engaged: sseTermResultSet.engaged, highRiskCourseEngagement: sseTermResultSet.highRiskCourseEngagement, lowRiskCourseEngagement: sseTermResultSet.lowRiskCourseEngagement, mediumRiskCourseEngagement: sseTermResultSet.mediumRiskCourseEngagement, notIndicatedRiskCourseEngagement: sseTermResultSet.notIndicatedRiskCourseEngagement, highRiskCourseCompletion: sseTermResultSet.highRiskCourseCompletion, lowRiskCourseCompletion: sseTermResultSet.lowRiskCourseCompletion, mediumRiskCourseCompletion: sseTermResultSet.mediumRiskCourseCompletion, notIndicatedRiskCourseCompletion: sseTermResultSet.notIndicatedRiskCourseCompletion, highRiskTermPersistence: sseTermResultSet.highRiskTermPersistence, mediumRiskTermPersistence: sseTermResultSet.mediumRiskTermPersistence, lowRiskTermPersistence: sseTermResultSet.lowRiskTermPersistence, notIndicatedRiskTermPersistence: sseTermResultSet.notIndicatedRiskTermPersistence, highRiskTermPersistenceEngagement: sseTermResultSet.highRiskTermEngagement, lowRiskTermPersistenceEngagement: sseTermResultSet.lowRiskTermEngagement, mediumRiskTermPersistenceEngagement: sseTermResultSet.mediumRiskTermEngagement, notIndicatedRiskTermPersistenceEngagement: sseTermResultSet.notIndicatedRiskTermEngagement, loader: false });
    }
    else {
        return __assign(__assign({}, state), { loader: false, termSummaryFailed: true });
    }
};
var defaultSseTermSummaryAction = {
    type: "",
    termResultSet: {
        showSseWidget: false,
        terms: []
    },
    sseTermResultSet: {
        averageCourseRisk: "",
        averageTermRisk: "",
        engaged: 0,
        highRiskCourseCompletion: 0,
        highRiskCourseEngagement: 0,
        highRiskTermEngagement: 0,
        highRiskTermPersistence: 0,
        lowRiskCourseCompletion: 0,
        lowRiskCourseEngagement: 0,
        lowRiskTermEngagement: 0,
        lowRiskTermPersistence: 0,
        mediumRiskCourseCompletion: 0,
        mediumRiskCourseEngagement: 0,
        mediumRiskTermEngagement: 0,
        mediumRiskTermPersistence: 0,
        notIndicatedRiskCourseCompletion: 0,
        notIndicatedRiskCourseEngagement: 0,
        notIndicatedRiskTermEngagement: 0,
        notIndicatedRiskTermPersistence: 0,
        totalEnrollments: 0
    },
    term: {
        endDate: "",
        id: "",
        name: "",
        startDate: ""
    },
    isExportInProgress: false,
    token: null
};
var stateReducer = function (state, action) {
    switch (action.type) {
        case "showLoader":
            return __assign(__assign({}, state), { loader: true, termSummaryFailed: false });
        case "setSseWidgetData":
            return __assign(__assign({}, state), { showSseWidget: action.termResultSet.showSseWidget, terms: action.termResultSet.terms, loader: action.termResultSet.terms.length > 0, selectedTerm: action.termResultSet.terms[0] });
        case "sseWidgetDataApiFail":
            return __assign(__assign({}, state), { showSseWidget: true, terms: [], loader: false, selectedTerm: null });
        case "setSseTermSummary":
            return setSseTermSummary(action.sseTermResultSet, state);
        case "sseTermSummaryApiFail":
            return __assign(__assign({}, state), { loader: false, termSummaryFailed: true });
        case "setSelectedTerm":
            return __assign(__assign({}, state), { selectedTerm: action.term });
        case "setExportInProgress":
            return __assign(__assign({}, state), { isExportInProgress: action.isExportInProgress });
        case "setToken":
            return __assign(__assign({}, state), { token: action.token });
        default:
            return state;
    }
};
export default function Sse() {
    var _a = useReducer(stateReducer, initialState), state = _a[0], dispatch = _a[1];
    var institution = useContext(AppContext).institution;
    useEffect(function () {
        var applyResult = function (result) {
            if (Array.isArray(result.terms) && result.terms.length > 0) {
                var term = result.terms[0];
                fetchTermSummary(term.id);
            }
            dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setSseWidgetData", termResultSet: result }));
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "sseWidgetDataApiFail" }));
        };
        sendRequest({ uri: "/sse/terms", camelize: true }, applyResult, onError);
    }, []);
    useEffect(function () {
        var liveRegion = document.querySelector(".sse-loader-status");
        getLoaderStatus(state.loader, liveRegion);
    }, [state.loader]);
    useEffect(function () {
        if (state.token && state.isExportInProgress) {
            exportToPdf();
        }
    }, [state.isExportInProgress, state.token]);
    useEffect(function () {
        if (state.isExportInProgress) {
            sendRequest({
                uri: "/export/token",
                camelize: true
            }, function (result) {
                dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setToken", token: result.token }));
            });
        }
    }, [state.isExportInProgress]);
    var fetchTermSummary = function (termId) {
        state.terms.forEach(function (term) {
            if (term.id === termId) {
                dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setSelectedTerm", term: term }));
            }
        });
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setSseTermSummary", sseTermResultSet: result }));
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "sseTermSummaryApiFail" }));
        };
        sendRequest({ uri: "/sse/risk_summary/term/".concat(termId), camelize: true }, applyResult, onError);
        dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "showLoader" }));
    };
    var predictedRiskTooltipText = useIntl().formatMessage({
        id: "app.sse.avgPredictedRiskDesc"
    });
    var studetOutreachTooltipText = useIntl().formatMessage({
        id: "app.sse.studentOutreachDesc"
    });
    var avgPredictedRiskInfoLabel = useIntl().formatMessage({
        id: "app.sse.avgPredictedRiskInfoLabel"
    });
    var studentOutreachInfoLabel = useIntl().formatMessage({
        id: "app.sse.studentOutreachInfoLabel"
    });
    var termLabel = useIntl().formatMessage({
        id: "app.sse.termLabel"
    });
    var TeamOverviewBody = function () {
        return (_jsx("div", { className: "body", children: _jsx("div", { className: "wm-grid", children: _jsxs("div", { className: "term-overview-main wm-grid-row", children: [_jsxs("div", { className: "enrollment wm-grid-col-2 wm-grid-col-lg-2 wm-grid-col-md-4 wm-grid-col-sm-8", children: [_jsx("div", { className: "titles", children: translate("app.sse.enrollmentLabel") }), _jsx("div", { className: "counts -enroll-count", children: formatNumber(state.totalEnrollments) }), _jsx("div", { className: "sub-text -enroll", children: translate("app.sse.studentUnduplicatedLabel") })] }), _jsxs("div", { className: "avg-predicted-risk wm-grid-col-3 wm-grid-col-lg-3 wm-grid-col-md-5 wm-grid-col-sm-8", children: [_jsxs("div", { className: "titles flex-row -verticallycentered", children: [_jsx("div", { children: translate("app.sse.predictedRiskLabel") }), _jsx("div", { className: "toggle-tip", children: _jsx(WmToggletip, { label: avgPredictedRiskInfoLabel, tooltip: predictedRiskTooltipText, tooltipPosition: "top-right" }) })] }), _jsxs("div", { className: "flex-row", children: [_jsxs("div", { className: "course-completion", children: [_jsx("div", { className: "counts", children: state.averageCourseRisk }), _jsx("div", { className: "sub-text", children: translate("app.sse.couseCompletionLabel") })] }), _jsxs("div", { className: "term-persistent", children: [_jsx("div", { className: "counts", children: state.averageTermRisk }), _jsx("div", { className: "sub-text", children: translate("app.sse.termPersistentLabel") })] })] })] }), _jsxs("div", { className: "student-outreach wm-grid-col-4 wm-grid-col-lg-4 wm-grid-col-md-5 wm-grid-col-sm-8", children: [_jsxs("div", { className: "titles flex-row -verticallycentered", children: [_jsx("div", { children: translate("app.sse.studentOutreachLabel") }), _jsx("div", { className: "toggle-tip", children: _jsx(WmToggletip, { label: studentOutreachInfoLabel, tooltip: studetOutreachTooltipText, tooltipPosition: "top-right" }) })] }), _jsxs("div", { className: "counts", children: [formatNumber(state.engaged), "/", formatNumber(state.totalEnrollments)] }), _jsx("div", { className: "sub-text -outreach", children: translate("app.sse.keyEngagementLabel") })] })] }) }) }));
    };
    var header = useIntl().formatMessage({
        id: "app.sse.studentInsightsLabel"
    });
    function exportToPdf() {
        var sseHtml = document.getElementById("sse-html");
        var downloadText = document.querySelector(".download-text");
        if (downloadText) {
            downloadText.setAttribute("tabindex", "0");
            downloadText.focus();
        }
        if (sseHtml) {
            var clone = sseHtml.cloneNode(true);
            var wrapperMain = document.createElement("main");
            wrapperMain.classList.add("main-container");
            wrapperMain.appendChild(clone);
            var wrapperDiv = document.createElement("div");
            wrapperDiv.appendChild(wrapperMain);
            var formData = new FormData();
            formData.append("html", wrapperDiv.outerHTML);
            formData.append("sub_header", encodeURIComponent(header));
            formData.append("header", "");
            formData.append("export_id", "student-insights-export");
            formData.append("_csrf_token", state.token ? state.token : "");
            var applyResult = function (result) {
                downloadPDF(result.pdf_file_bytes, "Student_Insights");
                dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setToken", token: null }));
                dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setExportInProgress", isExportInProgress: false }));
            };
            var onError = function () {
                dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setToken", token: null }));
                dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setExportInProgress", isExportInProgress: false }));
            };
            sendRequestWithPayload({
                uri: "/export",
                body: formData
            }, applyResult, onError);
        }
    }
    return state.showSseWidget ? (_jsx("section", { className: (institution === null || institution === void 0 ? void 0 : institution.navigatedFrom) === "planning"
            ? "body wm-grid sse-tab-body"
            : "body wm-grid tab-body-home", id: "sse-widget", children: _jsx("div", { children: _jsxs("section", { className: "insights", children: [_jsxs("div", { className: "institution-name -bottom flex-row -justified -verticallycentered sse-desc ", children: [_jsx("h3", { className: "helper-label helper-default-margin", children: header }), state.terms.length > 0 && (_jsxs("div", { className: "flex-row download-term-container", children: [!state.termSummaryFailed && (_jsxs("div", { className: "flex-row sse-export-button", children: [state.isExportInProgress && (_jsx("span", { className: "download-text", children: translate("app.planParticipation.exportPdf.downloadReportText") })), _jsx("div", { className: "button-container", children: _jsx(WmButton, { "button-type": "secondary", icon: "f1da", "icon-size": "14px", onClick: function () {
                                                        return dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setExportInProgress", isExportInProgress: true }));
                                                    }, disabled: state.isExportInProgress, children: translate("app.planParticipation.exportPdf.download") }) })] })), _jsx("div", { className: "terms-width", children: _jsx(WmSelect, { label: termLabel, labelPosition: "left", id: "select-terms", children: state.terms.map(function (term) {
                                                var _a;
                                                return (_jsx(WmOption, { id: "terms-".concat(term.id), onClick: function () { return fetchTermSummary(term.id); }, selected: ((_a = state.selectedTerm) === null || _a === void 0 ? void 0 : _a.id) === term.id, children: term.name }, "terms-".concat(term.id)));
                                            }) }) })] }))] }), !state.termSummaryFailed && (_jsxs("div", { className: "flex-row sse-export-button-small-screen", children: [state.isExportInProgress && (_jsx("span", { className: "download-text", children: translate("app.planParticipation.exportPdf.downloadReportText") })), _jsx("div", { className: "button-container-small-screen", children: _jsx(WmButton, { "button-type": "secondary", icon: "f1da", "icon-size": "14px", onClick: function () {
                                        return dispatch(__assign(__assign({}, defaultSseTermSummaryAction), { type: "setExportInProgress", isExportInProgress: true }));
                                    }, disabled: state.isExportInProgress, children: translate("app.planParticipation.exportPdf.download") }) })] })), state.terms.length > 0 && (_jsxs("div", { id: "sse-html", children: [_jsx("div", { className: "wm-grid-row", children: _jsx("div", { className: "grid-container wm-grid-col-12 wm-grid-col-md-10", children: _jsxs("div", { className: "paper-card paper-card-height", children: [_jsx("div", { className: "header", children: _jsxs("div", { className: "info", children: [_jsx("h3", { className: "title", children: translate("app.sse.termOverviewLabel") }), _jsx("p", { className: "description -des", children: translate("app.sse.termOverviewHelperText") })] }) }), _jsx("span", { className: "sr-only sse-loader-status", role: "status", "aria-live": "assertive" }), state.loader && (_jsx(WidgetLoader, { loaderContainerClasses: "loader-container", loaderClasses: "widget-loader" })), !state.loader && !state.termSummaryFailed && (_jsx(TeamOverviewBody, {})), state.termSummaryFailed && _jsx(ApiError, {})] }) }) }), _jsx("div", { id: "course-completion-risk-main", className: "wm-grid-row course-completion-risk-main -bottoms", children: _jsx(CourseCompletionRisk, { highRiskCourseEngagement: state.highRiskCourseEngagement, lowRiskCourseEngagement: state.lowRiskCourseEngagement, mediumRiskCourseEngagement: state.mediumRiskCourseEngagement, notIndicatedRiskCourseEngagement: state.notIndicatedRiskCourseEngagement, highRiskCourseCompletion: state.highRiskCourseCompletion, lowRiskCourseCompletion: state.lowRiskCourseCompletion, mediumRiskCourseCompletion: state.mediumRiskCourseCompletion, notIndicatedRiskCourseCompletion: state.notIndicatedRiskCourseCompletion, loader: state.loader, termSummaryFailed: state.termSummaryFailed }) }), _jsx("div", { id: "term-persistence-risk-main", className: "wm-grid-row course-completion-risk-main -bottoms", children: _jsx(TermPersistenceRisk, { highRiskTermPersistence: state.highRiskTermPersistence, mediumRiskTermPersistence: state.mediumRiskTermPersistence, lowRiskTermPersistence: state.lowRiskTermPersistence, notIndicatedRiskTermPersistence: state.notIndicatedRiskTermPersistence, highRiskTermPersistenceEngagement: state.highRiskTermPersistenceEngagement, lowRiskTermPersistenceEngagement: state.lowRiskTermPersistenceEngagement, mediumRiskTermPersistenceEngagement: state.mediumRiskTermPersistenceEngagement, notIndicatedRiskTermPersistenceEngagement: state.notIndicatedRiskTermPersistenceEngagement, loader: state.loader, termSummaryFailed: state.termSummaryFailed }) })] }))] }) }) })) : (_jsx("div", {}));
}
